import type { ImeiOut } from "@/lib/api";
import { ESTADO_IMEI_PILL, estadoImeiUI } from "@/lib/imei";

// Etiqueta compacta de un IMEI con color según su estado. Qué significa cada
// estado lo explica la Ayuda de la vista (`components/ayuda/vistas/fichasCaso`), no
// un tooltip. Es un <span> sin interacción a propósito: se renderiza dentro de
// filas-enlace (<a>), y un control dentro de un ancla rompería la navegación.
export default function ImeiChip({ imei }: { imei: ImeiOut }) {
  // estado_efectivo = semáforo conectado (manual o envejecimiento); mismo
  // criterio que el detalle del caso para que el chip se vea igual en todas
  // las vistas. Fallback a estado_manual por si el backend no lo manda.
  const estado = estadoImeiUI(imei.estado_efectivo ?? imei.estado_manual);
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-mono px-1.5 py-0.5 rounded border ${ESTADO_IMEI_PILL[estado]}`}
    >
      <span className="uppercase tracking-wide opacity-70">{estado}</span>
      <span>{imei.imei}</span>
    </span>
  );
}
